import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import {
  PlayArrow as UseIcon,
  Schedule as SeriesIcon,
} from '@mui/icons-material';

interface TemplateCardProps {
  slug: string;
  name: string;
  description: string;
  category: string;
  icon: string;
  onUseTemplate: (slug: string) => void;
  onCreateSeries: (slug: string) => void;
}

const CATEGORY_COLORS: Record<string, string> = {
  entertainment: '#e91e63',
  education: '#2196f3',
  lifestyle: '#4caf50',
  business: '#ff9800',
};

const TemplateCard: React.FC<TemplateCardProps> = ({
  slug,
  name,
  description,
  category,
  icon,
  onUseTemplate,
  onCreateSeries,
}) => {
  const color = CATEGORY_COLORS[category] || '#9c27b0';

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 6,
        },
      }}
    >
      <Box
        sx={{
          background: `linear-gradient(135deg, ${color}CC, ${color}66)`,
          p: 3,
          textAlign: 'center',
        }}
      >
        <Typography variant="h2" sx={{ fontSize: '3rem', mb: 1 }}>
          {icon}
        </Typography>
        <Typography variant="h6" sx={{ color: 'white', fontWeight: 700 }}>
          {name}
        </Typography>
      </Box>
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography
          variant="caption"
          sx={{
            color,
            textTransform: 'uppercase',
            fontWeight: 700,
            letterSpacing: 1,
            mb: 1,
          }}
        >
          {category}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, flexGrow: 1 }}>
          {description}
        </Typography>
        <Box display="flex" gap={1}>
          <Button
            variant="contained"
            size="small"
            startIcon={<UseIcon />}
            onClick={() => onUseTemplate(slug)}
            sx={{ flex: 1 }}
          >
            Use Template
          </Button>
          <Button
            variant="outlined"
            size="small"
            startIcon={<SeriesIcon />}
            onClick={() => onCreateSeries(slug)}
            sx={{ flex: 1 }}
          >
            Create Series
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TemplateCard;
